import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { PlayPauseFlashMessageRequest } from './playpauseflashmessagesrequest';

export class PlayPauseFlashMessageAPI extends SixdeeCRBTAPI<PlayPauseFlashMessageRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        return "flash/services/common/update-flashes";

    }

    protected getRequestData() {
       return {
            "status":this.getRequest().getStatus(),
            "msisdn":this.getRequest().getMsisdn()
        };
    }

    getBASEURL(): string
    {
        return this.getContext().getProperty().getFlashURL() + 
            this.getAPIURL();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/playpause/playpauseflashmessagesapi.tsx